import { render } from "./ProposersListModal.vue?vue&type=template&id=6edf4c9e"
import script from "./ProposersListModal.vue?vue&type=script&lang=js"
export * from "./ProposersListModal.vue?vue&type=script&lang=js"

import "./ProposersListModal.vue?vue&type=style&index=0&id=6edf4c9e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__